import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// import Modal from "react-bootstrap/Modal";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';

import FindModuleById from '.././FindModuleById';
//Material UI Imports
import {

  MenuItem,

} from '@mui/material';
const CalledCantacts = () => {
  const [menu, setMenu] = useState(false);
  // const [show, setShow] = useState(false);
 // const [selectedItemId, setSelectedItemId] = useState(null);
  const [businesses, setBusinesses] = useState([]);
  const [logistics, setLogistics] = useState([]);
  const [qualities, setQualities] = useState([]);
        const [permission, setPermission] = useState({});
 
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };



  const deleteItem = (item) => {

    Swal.fire({
      title: 'Do you really want to delete this record?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/called-contacts/delete/${item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/called-contacts";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });
  }
  

  // const customHandleInput = (event) => {
  //   const Input_name = event.target.name;
  //   delete backendErrors[Input_name];
  // };



  useEffect(() => {
 setPermission(FindModuleById(444)); 
console.log(permission);
  
    axios
      .post(
        "/called-contacts/listing",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          setBusinesses(response.data.data.business);
          setLogistics(response.data.data.logistics);
          setQualities(response.data.data.qualities);
        }else{
          window.location.href = "/login";
        }
       
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

 


  const editItem = (item)=>{
    window.location.href = "/called-contacts-edit/"+item;
  }

  const columns_business =
  [
  
     {
       accessorKey: 'name', 
       header: 'Name',
     }, 
     {
       accessorKey: 'email', 
       header: 'Email',
     }, 
     {
       accessorKey: 'phone_number', 
       header: 'Phone Number',
     }, 
     {
       accessorKey: 'position', 
       header: 'Position',
     }
   
   ];

  const columns_logistics =
  [
  
     {
       accessorKey: 'name', 
       header: 'Name',
     }, 
     {
       accessorKey: 'email', 
       header: 'Email',
     }, 
     {
       accessorKey: 'phone_number', 
       header: 'Phone Number',
     }, 
     {
       accessorKey: 'position', 
       header: 'Position',
     }
   
   ];
  
  const columns_quality =
  [
  
     {
       accessorKey: 'name', 
       header: 'Name',
     }, 
     {
       accessorKey: 'email', 
       header: 'Email',
     }, 
     {
       accessorKey: 'phone_number', 
       header: 'Phone Number',
     }, 
     {
       accessorKey: 'position', 
       header: 'Position',
     }
   
   ];
  return (
    <>
   
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Contacts
                  </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">Contacts    </li>
                  </ul>
                </div>
                <div className="col-auto">
                  <Link to="/called-contacts-add" className="btn btn-primary me-1">
                    <i className="fas fa-plus"></i>
                  </Link>
                </div>
              </div>
            </div>
         
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table"  style={{padding:'20px'}}>
                    <h5 className="card-header" style={{padding:'0px'}} >Business</h5>
                  <div className="card-body">
                 
                    <div className="table-responsive">
                    
                       <MaterialReactTable columns={columns_business} data={businesses} 
                                    // enableColumnFilterModes
                                    enableColumnOrdering
                                    // enableGrouping
                                    enablePinning
                                    enableRowActions
                                   
                                    renderRowActionMenuItems={({ row }) => [
                                      permission?.update === 1 && (
                                        <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                          Edit
                                        </MenuItem>
                                      ),
                                      permission?.delete === 1 && (
                                        <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                          Delete
                                        </MenuItem>
                                      ),
                                    ]}
                                  />
                        </div>
                 
                  </div>
                </div>
              </div>
            </div>

        <div className="row">
              <div className="col-sm-12">
                <div className="card card-table"  style={{padding:'20px'}}>
                    <h5 className="card-header" style={{padding:'0px'}}>Logistics</h5>
                  <div className="card-body">
                 
                    <div className="table-responsive">
                    
                       <MaterialReactTable columns={columns_logistics} data={logistics} 
                                    // enableColumnFilterModes
                                    enableColumnOrdering
                                    // enableGrouping
                                    enablePinning
                                    enableRowActions
                                   
                                    renderRowActionMenuItems={({ row }) => [
                                      permission?.update === 1 && (
                                        <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                          Edit
                                        </MenuItem>
                                      ),
                                      permission?.delete === 1 && (
                                        <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                          Delete
                                        </MenuItem>
                                      ),
                                    ]}
                                  />
                        </div>
                 
                  </div>
                </div>
              </div>
            </div>
              <div className="row">
              <div className="col-sm-12">
                <div className="card card-table"  style={{padding:'20px'}}>
                    <h5 className="card-header" style={{padding:'0px'}}>Quality</h5>
                  <div className="card-body">
                 
                    <div className="table-responsive">
                    
                       <MaterialReactTable columns={columns_quality} data={qualities} 
                                    // enableColumnFilterModes
                                    enableColumnOrdering
                                    // enableGrouping
                                    enablePinning
                                    enableRowActions
                                   
                                    renderRowActionMenuItems={({ row }) => [
                                      permission?.update === 1 && (
                                        <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                          Edit
                                        </MenuItem>
                                      ),
                                      permission?.delete === 1 && (
                                        <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                          Delete
                                        </MenuItem>
                                      ),
                                    ]}
                                  />
                        </div>
                 
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
};
export default CalledCantacts;
